var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventInfoSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "17px",
    viewBox: "0 0 13 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EventInfoSurvey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer-Dashboard-\\u2014-Before-Event",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-751.000000, -876.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upcoming-event-card-copy-7",
    transform: "translate(733.000000, 758.000000)",
    fill: "#848484",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "event-basics-in-list-form",
    transform: "translate(16.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67726667,79.6874667 C9.49317175,79.6874667 9.34393333,79.5382282 9.34393333,79.3541333 L9.34393333,75.8255667 C9.34393516,75.6907559 9.425139,75.5692185 9.54968436,75.5176201 C9.67422972,75.4660217 9.81759333,75.4945221 9.91293333,75.5898333 L13.4416,79.1184667 C13.5369112,79.2138067 13.5654116,79.3571703 13.5138132,79.4817156 C13.4622148,79.606261 13.3406774,79.6874648 13.2058667,79.6874667 L9.67726667,79.6874667 Z M14.0106,81.3541333 L14.0106,90.0208 C14.0106,90.5730847 13.5628847,91.0208 13.0106,91.0208 L3.0106,91.0208 C2.45831525,91.0208 2.0106,90.5730847 2.0106,90.0208 L2.0106,76.0208 C2.0106,75.4685153 2.45831525,75.0208 3.0106,75.0208 L7.67726667,75.0208 C8.22955142,75.0208 8.67726667,75.4685153 8.67726667,76.0208 L8.67726667,79.3541333 C8.67726667,79.9064181 9.12498192,80.3541333 9.67726667,80.3541333 L13.0106,80.3541333 C13.5628066,80.3542438 14.0104,80.8019267 14.0104,81.3541333 L14.0106,81.3541333 Z",
    id: "EventInfoSurvey"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventInfoSurvey);
export default __webpack_public_path__ + "static/media/EventInfoSurvey.f0a39751abbaaa4d73a6b42362e05847.svg";
export { ForwardRef as ReactComponent };